<template>
  <div>    
    <template v-if="isOtherOption || forceOtherOption">
      <input
        type="text"
        class="form-control"
        :placeholder="otherOptionPlaceholder"
        :value="value"
        @input="onInput"
        :class="classes"
        :disabled="disabled"
      />
      <button v-if="!forceOtherOption" class="btn btn-sm btn-link" @click="onClickBackToList">Voltar a escolher da lista</button>
    </template>
    <template v-else>
      <v-select
        :placeholder="placeholder"
        :clearable="false"
        :label="label"
        :reduce="reduce"
        :options="options"
        :value="value"
        @input="onInputList"
        :class="classes"
        :disabled="disabled"
      >
        <template v-slot:no-options>
          <div>Nenhum resultado.</div>
        </template>
        <template v-slot:list-footer>
          <div class="text-center">
            <button
              class="btn btn-sm btn-link"
              @click="onClickOtherOption"
            >{{otherOptionText || 'Informar outra opção'}}</button>
          </div>
        </template>
      </v-select>
    </template>
  </div>
</template>

<script>

export default {
  props: [
    "placeholder",
    "label",
    "reduce",
    "options",
    "value",
    "otherOptionText",
    "otherOptionPlaceholder",
    "classes",
    "forceOtherOption",
    "disabled"
  ],
  data() {
    return {
      isOtherOption: false
    };
  },
  watch:{
      forceOtherOption: function(newValue, oldValue){
          if(newValue != oldValue){
              this.isOtherOption = newValue;
              this.$emit("otherOptionChanged", newValue);
          }
      }
  },
  methods: {
    onInput(ev) {
      this.$emit("input", ev.target.value);
    },
    onInputList(newValue) {
      this.$emit("input", newValue);
      this.$emit("optionSelected");
    },
    onClickOtherOption() {
      this.isOtherOption = true;
      this.$emit("otherOptionChanged", this.isOtherOption);
      this.onInputList(undefined);
    },
    onClickBackToList() {
      this.isOtherOption = false;
      this.$emit("otherOptionChanged", this.isOtherOption);
      this.onInputList(undefined);
    }
  }
};
</script>